module.exports = __webpack_public_path__ + "static/brass-dragon-25769845482a2a55d0925cdb3436e182.jpg";